import { genericAuthenticatedFetch, genericAuthenticatedPut } from './index';

export async function getStylingDictionary() {
  return genericAuthenticatedFetch('resources/styling/dictionary/get');
}

export async function updateStylingDictionary(data) {
  let json = JSON.stringify(data);
  return genericAuthenticatedPut(`resources/styling/dictionary/update`, json);
}